import { render, staticRenderFns } from "./test.vue?vue&type=template&id=652be7ce&scoped=true"
import script from "./test.vue?vue&type=script&setup=true&lang=js"
export * from "./test.vue?vue&type=script&setup=true&lang=js"
import style0 from "./test.vue?vue&type=style&index=0&id=652be7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652be7ce",
  null
  
)

export default component.exports